export default __webpack_public_path__ + "static/media/mazda.e287dda8.png";